import type { JSX } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { useMutation } from "urql";
import getLocale from "../../../shared/getLocale";
import { graphql } from "../../gql";
import PulseForm, { type IFormValues } from "../../pulse/PulseForm";
import type { IPulse, ITask, ITaskVariant } from "../query";

export const createMutation = graphql(`
    mutation AppPulseCreateForTask($data: PlayerPulseCreateForTaskData!) {
        pulseCreateForTask(data: $data) {
            error
            pulse {
                id
                submittedTaskVariant {
                    id
                    submittedTask {
                        id
                        task { id }
                    }
                }
            }
        }
    }
`);

interface IProps {
    task: ITask;
    variant: ITaskVariant;
    pulse: IPulse | null;
}

function Setup({ task, variant, pulse }: IProps): JSX.Element {
    const [createResult, executeCreate] = useMutation(createMutation);
    const navigate = useNavigate();

    if (pulse) {
        return <Navigate to={`/pulse/${pulse.id}/results`} />;
    }

    const onSubmit = async (values: IFormValues) => {
        if (createResult.fetching) {
            return;
        }
        const args = {
            data: {
                locale: getLocale(),
                question1: values.question1,
                question2: values.question2,
                id: task.id,
                variantId: variant.id,
                name: null,
            },
        };
        const result = await executeCreate(args);
        const payloadError = result.data?.pulseCreateForTask?.error;
        const pulseId = result.data?.pulseCreateForTask?.pulse?.id;
        if (result.error || payloadError || !pulseId) {
            console.error(result.error || payloadError);
        } else {
            navigate(`../${pulseId}/results`, { relative: "path" });
        }
    };

    return <PulseForm onSubmit={onSubmit} pulseSuggestedQuestions={variant.pulseSuggestedQuestions} />;
}

export default Setup;
